export class Distributor{
    public Id : Number;
    public IsActive : Boolean = true;
    public Code : String;
    public Name : String;
    public Address : String;
    public PostalCodeId : Number = 0;
    public CityId : Number = 0;
    public CountryId : Number = 0;
    public Website : String;
    public VAT : String;
    public ContactPerson : String;
    public Phone : String;
    public Email: String;
    public IncludeInFinance : Boolean = true;
    public DepotTypeId : Number = 0;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/distributor.model.ts